import React from "react";
import * as Icons from "lucide-react";

export function StatCard({ label, value, hint, tone = "default", testId, icon, right }) {
  const color =
    tone === "danger" ? "var(--danger)"
    : tone === "warn" ? "var(--warn)"
    : tone === "ok" ? "var(--success)"
    : "var(--ink)";
  const softBg =
    tone === "danger" ? "var(--danger-soft)"
    : tone === "warn" ? "var(--warn-soft)"
    : tone === "ok" ? "var(--success-soft)"
    : "var(--bg-2)";
  const Ico = icon ? (Icons[icon] || null) : null;
  return (
    <div
      data-testid={testId}
      className="relative surface rounded-xl p-5 card-shadow card-hover overflow-hidden"
      style={{ border: "1px solid var(--border)" }}
    >
      {/* Tone accent bar */}
      <div aria-hidden className="absolute top-0 left-0 h-0.5 w-full opacity-90" style={{ background: `linear-gradient(90deg, ${color}, transparent)` }} />
      <div className="flex items-start justify-between mb-4">
        <div className="label-cap">{label}</div>
        {Ico ? (
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: softBg }}>
            <Ico className="w-4 h-4" style={{ color }} strokeWidth={2} />
          </div>
        ) : right}
      </div>
      <div className="num-display text-3xl leading-none" style={{ color }}>
        {value}
      </div>
      {hint && <div className="mt-2 text-xs muted">{hint}</div>}
    </div>
  );
}
